import { Component, ViewChild, ViewContainerRef } from '@angular/core'
import { CtrlBaseComponent } from '../ctrl-base.component';
import { InputBaseComponent } from '../input-base.component';
import { ADN_PLUS } from '../../models/ADN_Plus';

@Component({
  selector: 'ct-bar-filter',
  templateUrl: './ct-bar-filter.component.html',
  styleUrls: ['./ct-bar-filter.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()',
    '[class]': "'bar-filter-panel'"
  }
})
export class CtBarFilterComponent extends CtrlBaseComponent {

  @ViewChild('filtersTarget', { read: ViewContainerRef }) filtersTarget: ViewContainerRef;
  @ViewChild('btnsTarget', { read: ViewContainerRef }) btnsTarget: ViewContainerRef;
  
  constructor() {
    super();
  }

  ngAfterViewInit() {
    let metadata = this.getMetaData();

    for (let inputMetadata of metadata.models)
      inputMetadata.controlProperties.oneLineControl = true;

    this.paintChildren(this.getMetaData(), this.filtersTarget);
    this.setOnEnterToModels();
    this.addButtons();
  }

  private setOnEnterToModels(): void {
    let action = {
      "eventName": 'onEnter',
      "type": 2,
      "action": this.getId() + ".search"
    }

    for (let input of this.childElements) {
      if (input instanceof InputBaseComponent)
        input.getControlActions().push(action);
    }
  }

  private addButtons(): void {
    let btnsModels = {
      models: [
        {
          id: this.getId() + "_btnSearch",
          ctType: "CtButton",
          controlProperties: {
                hidden: false,
                listenedComponentId: "",
                listenedProperty: "",
                disabled: false,
                id: this.getId() + "btnSearch",
                modelId: "",
                pickId: "",
                buttonColor: "Primary",
                buttonText: " Buscar",
                icon: "fa fa-search",
                btnBlock: true
          },
          controlActions: [
            {
              "eventName": "onClick",
              "type": 2,
              "action": this.getId() + ".search"
            }
          ],
          models: []
        },
        {
          id: this.getId() + "_btnClean",
          ctType: "CtButton",
          controlProperties: {
            hidden: false,
            listenedComponentId: "",
            listenedProperty: "",
            disabled: false,
            modelId: "",
            pickId: "",
            id: this.getId() + "_btnClean",
            buttonText: "Limpiar",
            buttonColor: "Default",
            icon: "",
            btnBlock: true
          },
          controlActions: [
            {
              "eventName": 'onClick',
              "type": 2,
              "action": this.getId() + ".cleanFilters"
            }
          ],
          models: []
        }
      ]
    };

    this.paintChildren(btnsModels, this.btnsTarget);
  }

  public search(): void {
    let event = this.getEvent('onSearch');
    if (event)
      this.executeAction2(event);
  }

  public cleanFilters(): void {
    let onClean = this.getEvent('onClean');
    if (onClean)
      this.executeAction2(onClean);

    let inputChilds = [];
    inputChilds = this.childElements.slice(0, -2);
    for (let inputChild of inputChilds) {
      let onInit = inputChild.getEvent('onInit');
      inputChild.resetToInitState();
      if (onInit)
        this.executeAction2(onInit);
      else
        inputChild.formControl.reset(inputChild.getInitValue());
    }
  }

  public setAndSearch(adnToBind: ADN_PLUS): void {
    for (let el of this.childElements) {
      if (el.getCtType() == 'CtButton')
        continue;

      let fieldValue = adnToBind.ArrayEntities.List.find(x => {
        return (x ? x.Name === el.getModelId() ? x.Name === el.getModelId() : x.Alias === el.getModelId() : false);
      });

      if (fieldValue && el instanceof InputBaseComponent)
        el.setValue(fieldValue.Value)
    }

    this.search();
  }
}

